import Vue from "vue";

/**
 * MiniCart Header Component
 */
const MinicartHeader = Vue.component("minicart-header", {
    template: `
        <div class="minicart-header d-flex align-items-center justify-content-between">
            <input type="hidden" name="minicartDataLayer" :value="minicartDataLayerObject" />
            <div>
                <h3 class="minicart-title m-0">{{resources ? resources.header: ""}}</h3>
            </div>
            <div>
                <button type="button"
                    class="minicart-close"
                    :title="resources.closeTooltip">
                    <span v-html="icon" />
                </button>
            </div>
        </div>`
    ,
    props: ["resources", "icon", "minicartDataLayerObject"]
});

/**
 * MiniCart Area de Entrega Component
 */
const MinicartAreaEntrega = Vue.component("minicart-areaentrega", {
    template: `
    <div class="minicart-area-inner" :data-entrega-zero-delay="resources.entregaZeroDelayTime">
        <div class="d-flex justify-content-center align-items-center" v-if="!resources.isEntregaZero">
            <a :href="resources.entregaZeroInactiveAction" class="minicart-area-action">{{resources.entregaZeroMsg}}</a>
            <span> {{resources.entregaZeroMsgConjuction}} </span>
            <span class="d-flex ml-2" v-html="icon" />
        </div>
        <div class="d-flex justify-content-center align-items-center" v-else>
            <span v-html="activeIcon" />
            <span class="mx-2" v-html="icon" />
            <span> {{resources.entregaZeroActive}} </span>
        </div>
    </div>`
    ,
    props: ["resources", "icon", "activeIcon"]
});

/**
 * MiniCart Footer Component
 */
const MinicartFooter = Vue.component("minicart-footer", {
    template: `
        <div id="minicart-footer">
            <div class="minicart-empty-action text-center pwc-mb--15" v-if="isEmpty">
                <a class="button button--primary minicart-continue-button" role="button" :href="resources.emptyCartActionUrl">
                    <span class="minicart-empty-label">{{resources.emptyCartActionMessage}}</span>
                </a>
            </div>

            <div class="minicart-footer" v-else>
                <div :class="campaignBenefitThreshold.mainclass">
                    <div class="campaignBenefitThreshold_message">
                        <span class="campaignBenefitThreshold_message_add">{{campaignBenefitThreshold.messages.add}}</span>
                        <span class="campaignBenefitThreshold_message_value">{{campaignBenefitThreshold.messages.value}}</span>
                        <span class="campaignBenefitThreshold_message_addtoget">{{campaignBenefitThreshold.messages.addtoget}}</span>
                        <span class="campaignBenefitThreshold_message_discount">{{campaignBenefitThreshold.messages.discount}}</span>
                        <span class="campaignBenefitThreshold_message_applied">{{campaignBenefitThreshold.messages.applied}}</span>
                        <span :class="campaignBenefitThreshold.reachedclasses" v-html="activeAreaEntregaIcon" />
                    </div>
                    <div class="threshold_campaign_bar">
                        <div class="threshold_campaign_bar_value" :style="{width: campaignBenefitThreshold.percentage}"></div>
                    </div>
                </div>
                <div class="minicart-estimated-total d-flex align-items-center justify-content-between">
                    <div class="minicart-area-entrega mr-auto" v-if="!isEmpty && resources.customerAuthenticated">
                        <minicart-areaentrega :resources="resources" :icon="areaEntregaIcon" :active-icon="activeAreaEntregaIcon" />
                    </div>
                    <div>
                        <p class="minicart-subtotal-label m-0 mr-sm-4 m-md-0">{{resources.subtotal}}</p>
                    </div>
                    <div v-if="!hideZeroPrice">
                        <p class="minicart-subtotal m-0">{{subTotal}}</p>
                    </div>
                </div>
                <div class="row no-gutters">
                    <div class="col minicart-clean-col">
                        <a class="button button--secondary minicart-clean-button" role="button">
                            <span v-html="trashIcon" />
                        </a>
                    </div>
                    <div class="col">
                        <a class="button button--primary minicart-add-button" role="button" :href="resources.buyAction">
                            <span v-html="icon" />
                            <span class="minicart-add-label">{{resources.buyTitle}}</span>
                        </a>
                    </div>
                </div>
                <div class="minicart-minimumOrderValue row no-gutters justify-content-center" v-if="minimumOrderValueBlocked">
                    <span v-html="infoIcon" /> {{resources.minimumOrderValueWarning}}
                </div>
            </div>

            <div class="minicart-area-entrega" v-if="!isEmpty && resources.customerAuthenticated">
                <minicart-areaentrega :resources="resources" :icon="areaEntregaIcon" :active-icon="activeAreaEntregaIcon" />
            </div>
        </div>`
    ,
    props: ["resources", "minimumOrderValueBlocked", "icon", "active-icon", "infoIcon", "trashIcon", "isEmpty", "subTotal", "hideZeroPrice", "areaEntregaIcon", "activeAreaEntregaIcon", "campaignBenefitThreshold"],
    components: {
        MinicartAreaEntrega
    }
});

/**
 * MiniCart Empty Component
 */
const MinicartEmpty = Vue.component("minicart-empty", {
    template: `
        <div class="minicart-empty-container">
            <div class="minicart-empty-icons text-center">
                <span v-html="icon" />
            </div>
            <h2 class="minicart-empty-title pwc-h2">{{resources.emptyCartTitle}}</h2>
            <p class="minicart-empty-description col-sm-8 col-md-12">{{resources.emptyCartMessage}}</p>
        </div>`
    ,
    props: ["resources", "icon"]
});

export { MinicartHeader, MinicartFooter, MinicartEmpty};
